/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { node } from 'prop-types';
import React, { useEffect, useState } from 'react';

/**
 *
 * @param {*} param0
 * @returns it use to clear the old login state and fetch always from server side for initial load
 */
const FiveOWrapper = ({ children }) => {
    const [loaded, setLoad] = useState(null);
    window.localStorage.removeItem('userInfo');
    useEffect(() => {
        setLoad(true);
    }, []);
    if (loaded) {
        return <>{children}</>;
    }
    return <></>;
};

FiveOWrapper.propTypes = {
    children: node.isRequired,
};

export default FiveOWrapper;
